import React, { useEffect, useState } from "react";

//redux
import { connect, useDispatch, useSelector } from "react-redux";

//MUI
import { Dialog, DialogContent } from "@mui/material";

//types
import { CLOSE_NEW_REDEEM_DIALOG } from "../../store/redeem/types";

//action
import { createAgencyRedeem, getSetting } from "../../store/redeem/action";
import { getProfile } from "../../store/admin/action";
import useTranslation from "../../hooks/useTranslation";

const SUBMIT_GRAD = "linear-gradient(84.57deg, #FD297E 0%, #6B01FF 100%)";

const inputStyle = {
  backgroundColor: "#FFFFFF1A",
  border: "0.5px solid #FFFFFF26",
  padding: "14px 16px",
  borderRadius: 12,
  width: "100%",
  color: "#FFFFFF",
  fontSize: 16,
  fontWeight: 300,
  lineHeight: 1,
  outline: "none",
  boxSizing: "border-box",
};

const labelStyle = {
  display: "block",
  color: "#FFFFFF",
  fontSize: 16,
  fontWeight: 500,
  marginBottom: 10,
};

const AgencyRedeemCreate = (props) => {
  const dispatch = useDispatch();

  const {
    dialog: open,
    dialogData,
    setting,
  } = useSelector((state) => state.redeem);
  const { t } = useTranslation();

  const { seller } = useSelector((state) => state.admin);

  const agencyId = localStorage.getItem("agencyId");
  const [coin, setCoin] = useState();
  const [description, setDescription] = useState("");
  const [paymentGateway, setPaymentGateway] = useState("");
  const [errors, setError] = useState({
    description: "",
    coin: "",
  });

  useEffect(() => {
    if (dialogData) {
      setDescription(dialogData.description);
      setPaymentGateway(dialogData.paymentGateway);
    }
  }, [dialogData]);

  // useEffect(() => {
  //   props.getSetting();
  //   props.getProfile();
  // }, []);

  useEffect(
    () => () => {
      setError({
        description: "",
        paymentGateway: "",
        coin: "",
      });
      setDescription("");
      setPaymentGateway("");
      setCoin("");
    },
    [open],
  );

  useEffect(() => {
    window.onbeforeunload = closePopup();
  }, []);

  const closePopup = () => {
    dispatch({ type: CLOSE_NEW_REDEEM_DIALOG });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    let error = {};

    if (!description) error.description = "Description is required!";
    if (!coin) error.coin = "Coin is required!";
    if (coin < setting?.minRcoinForCashOutAgency)
      error.coin = `Minimum cashout amount is ${setting?.minRcoinForCashOutAgency}`;

    if (Object.keys(error).length > 0) {
      setError(error);
      return;
    }

    const data = {
      agencyId: dialogData?._id,
      description,
      coin: parseInt(coin),
      agencyId,
    };

    dispatch(createAgencyRedeem(data));

    // Add your submit action here
    closePopup();
  };

  return (
    <>
      <Dialog
        open={open}
        aria-labelledby="responsive-dialog-title"
        onClose={closePopup}
        disableEscapeKeyDown
        fullWidth
        maxWidth="xs"
        style={{ zIndex: 9999999 }}
        BackdropProps={{
          sx: {
            backgroundColor: "rgba(0, 0, 0, 0.75) !important",
            background: "rgba(0, 0, 0, 0.75) !important",
          },
        }}
        sx={{
          "& .MuiBackdrop-root": {
            backgroundColor: "rgba(0, 0, 0, 0.75) !important",
            background: "rgba(0, 0, 0, 0.75) !important",
          },
        }}
        PaperProps={{
          sx: {
            background: "#381559 !important",
            borderRadius: "16px !important",
            color: "#fff !important",
            overflow: "hidden !important",
            margin: "16px !important",
            maxWidth: "360px !important",
            width: "100%",
          },
        }}
      >
        {/* Header — CoinSeller-style */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            position: "relative",
            padding: "20px 48px 16px",
            borderBottom: "1px solid rgba(255,255,255,0.10)",
          }}
        >
          <p
            style={{
              color: "#FFFFFF",
              fontSize: 18,
              fontWeight: 600,
              margin: 0,
              textAlign: "center",
            }}
          >
            {t("agency_redeem", "Agency Redeem")}
          </p>
          <button
            type="button"
            onClick={closePopup}
            aria-label="Close"
            style={{
              position: "absolute",
              right: 14,
              top: "50%",
              transform: "translateY(-50%)",
              width: 35,
              height: 35,
              borderRadius: "50%",
              border: "none",
              background: "#FFFFFF1A",
              color: "#fff",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              padding: 0,
              lineHeight: 0,
            }}
          >
            <svg
              width="20"
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              stroke="#FFFFFF"
              strokeWidth="2.6"
              strokeLinecap="round"
              style={{ display: "block", flexShrink: 0 }}
            >
              <line x1="18" y1="6" x2="6" y2="18" />
              <line x1="6" y1="6" x2="18" y2="18" />
            </svg>
          </button>
        </div>

        <DialogContent style={{ padding: "18px 20px 22px" }}>
          <form onSubmit={handleSubmit}>
            <div style={{ marginBottom: 16 }}>
              <label style={labelStyle}>{t("coin", "Coin")}</label>
              <input
                type="number"
                placeholder={t("coin", "Coin")}
                value={coin}
                onChange={(e) => {
                  setCoin(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...errors,
                      coin: "coin is Required!",
                    });
                  } else {
                    return setError({
                      ...errors,
                      coin: "",
                    });
                  }
                }}
                style={inputStyle}
              />
              {errors.coin && (
                <div style={{ marginTop: 6 }}>
                  <span style={{ color: "#FF0000", fontSize: 13 }}>{errors.coin}</span>
                </div>
              )}
            </div>

            <div>
              <label style={labelStyle}>{t("description", "Description")}</label>
              <input
                type="text"
                placeholder={t("description", "Description")}
                value={description}
                onChange={(e) => {
                  setDescription(e.target.value);
                  if (!e.target.value) {
                    return setError({
                      ...errors,
                      description: "Description is Required!",
                    });
                  } else {
                    return setError({
                      ...errors,
                      description: "",
                    });
                  }
                }}
                style={inputStyle}
              />
              {errors.description && (
                <div style={{ marginTop: 6 }}>
                  <span style={{ color: "#FF0000", fontSize: 13 }}>
                    {errors.description}
                  </span>
                </div>
              )}
            </div>
          </form>

          <button
            type="button"
            onClick={handleSubmit}
            style={{
              width: "100%",
              marginTop: 28,
              padding: "15px",
              border: "none",
              borderRadius: 999,
              background: SUBMIT_GRAD,
              color: "#FFFFFF",
              fontWeight: 600,
              lineHeight: 1,
              fontSize: 18,
              cursor: "pointer",
            }}
          >
            {t("submit", "Submit")}
          </button>
        </DialogContent>
      </Dialog>
    </>
  );
};

export default connect(null, {
  createAgencyRedeem,
  getSetting,
  getProfile,
})(AgencyRedeemCreate);
